import React from 'react';

const TicketIcon = ({ size = "68" }: { size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3449 34.0186C15.9601 33.219 15.0626 33.0999 13.631 33.4835L12.1008 27.7726C11.8149 26.7057 12.4481 25.609 13.515 25.3231L37.3877 18.9265L44.2889 44.6818L20.4162 51.0785C19.3492 51.3644 18.2526 50.7312 17.9667 49.6643L16.4365 43.9534C17.868 43.5698 18.5857 43.0179 19.3852 41.6331C20.9843 38.8634 20.1147 35.6177 17.3449 34.0186Z"
        fill="#E6F3F4"
        stroke="#4A9CA6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M49.4272 47.2261L39.2403 44.4796L46.132 18.7595L56.3272 21.4764C57.3955 21.7611 58.0302 22.8587 57.744 23.9266L56.2145 29.6349C54.783 29.2513 53.8855 29.3704 52.5006 30.1699C49.7309 31.769 48.8612 35.0147 50.4603 37.7844C51.2599 39.1693 51.9776 39.7212 53.4091 40.1048L51.8797 45.8127C51.5935 46.8808 50.4949 47.5139 49.4272 47.2261Z"
        fill="white"
        stroke="#4A9CA6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TicketIcon;
